qw-modal-room-details {
  .qw-room-list-card__details-popup-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 13;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .qw-room-list-card__details-popup-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: var(--qw-hotel-neutral-lightest);
    width: 90%;
    max-width: 1680px;
    height: auto;
    max-height: 80vh;
    overflow: auto;
    padding: var(--qw-hotel-gap-lg);
  }

  /* Avoid showing images */
  .qw-room-list-card__details-popup-content
    .qw-carousel
    .swiper-wrapper
    .swiper-slide {
    overflow: hidden;
  }

  .qw-room-list-card__details-popup-content .content-info__room-details h3,
  .qw-room-list-card__details-popup-content .content-info__services h3 {
    font-family: var(--qw-hotel-font-family-b);
    font-size: 20px;
  }

  .qw-room-list-card__details-popup-content .qw-room-base-info-list {
    margin: 18px 0 54px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }
  .qw-room-list-card__details-popup-content .content-info__services {
    width: 100%;
    flex-wrap: wrap;
  }

  .qw-room-list-card__details-popup-content
    .qw-room-base-info-list:last-of-type {
    margin-bottom: 0;
  }

  .qw-room-list-card__details-popup-content .qw-room-base-info-list li {
    min-width: 25%;
    justify-content: flex-start;
  }

  .qw-room-list-card__details-popup-content .qw-room-base-info-list li p {
    margin: 0;
    line-height: 1.2;
    text-align: left;
  }

  .qw-room-list-card__details-popup-content .close-icon {
    position: absolute;
    top: var(--qw-hotel-gap-sm);
    right: var(--qw-hotel-gap-sm);
    width: 30px;
    height: 30px;
    margin: var(--qw-hotel-gap-lg);
    z-index: 100;
    background: url('#{$base-url}img/icons/close-pop.svg') no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .qw-room-list-card__details-popup-content .content-info {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    width: 60%;
    padding-right: 40px;
  }

  .qw-room-list-card__details-popup-content
    .content-info
    .content-info__room-details {
    width: 100%;
  }

  .qw-room-list-card__details-popup-content .content-info h2 + p {
    margin: 27px 0 41px;
  }
  .qw-room-list-card__details-popup-content .content-info h2 + p > p {
    margin: 0;
  }

  .qw-room-list-card__details-popup-content .content-carousel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
  }

  .qw-room-list-card__details-popup-content .content-carousel qw-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .qw-room-list-card__details-popup-content
    .qw-room-base-info-list
    .qw-room-base-info__item
    .qw-room-base-item--container {
    flex-direction: row;
  }

  .qw-room-list-card__details-popup-content h2 {
    margin: 0;
    padding: 0;
    font-family: var(--qw-hotel-font-family-b);
    font-size: 24px;
    margin: 0px 0 0;
    line-height: 1.2;
  }
}

@media only screen and (max-width: 1480px) {
  .qw-room-list-card__details-popup-content h2 {
    font-size: 21px;
  }
}

@media only screen and (max-width: 1380px) {
  .qw-room-list-card__details-popup-content h2 {
    font-size: 20px;
  }
}
@media only screen and (max-width: 1280px) {
  .qw-room-list-card__details-popup-content .qw-room-base-info-list li {
    max-width: 100%;
  }

  .qw-room-list-card__details-popup-content h2 {
    font-size: 19px;
  }
}

@media only screen and (max-width: 1024px) {
  .qw-room-list-card__details-popup-content h2 {
    font-size: 21px;
  }
}

@media only screen and (max-width: 738px) {
  qw-modal-room-details {
    display: none;
  }
}
